/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { useToken } from "../hooks/use-token";
import sweetAlert from "../components/sweet-alert";

const AuthContext = React.createContext({
  accessToken: "",
  accessTokenExpiry: "",
  refreshToken: "",
  refreshTokenExpiry: "",
  isLoggedIn: false,
  isUserVerified: false,
  verifyUser: () => {},
  login: (accessToken, accessTokenExpiry, refreshToken, refreshTokenExpiry) => {
    if ((accessToken, accessTokenExpiry, refreshToken, refreshTokenExpiry))
      return "";
  },
});

export default AuthContext;

export function AuthContextProvider(props) {
  const [token, setToken] = useToken();
  const [refreshToken, setRefreshToken] = useState("");
  const userIsLoggedIn = Boolean(token);
  const [userIsUserVerified, setUserIsUserVerified] = useState(false);

  useEffect(() => {
    //call this function to start timer in case of refresh
    // sessionExpiryTimeHandler();
    const _isUserVerifies = localStorage.getItem("is-user-verified");
    if (_isUserVerifies) {
      setUserIsUserVerified(true);
    }
  }, []);

  const loginHandler = (
    accessToken,
    accessTokenExpiry,
    refreshToken,
    refreshTokenExpiry,
  ) => {
    sessionStorage.setItem("auth-expiry-time", accessTokenExpiry);
    sessionStorage.setItem("refresh-expiry-time", refreshTokenExpiry);
    sessionStorage.setItem("refresh-token", refreshToken);
    setToken(accessToken);
    setRefreshToken(refreshToken);
    localStorage.setItem("token", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
  };
  const verifyUser = () => {
    setUserIsUserVerified(true);
    localStorage.setItem("is-user-verified", "true");
  };
  const logoutHandler = () => {
    appLogout();
  };

  const contextValue = {
    token,
    refreshToken,
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler,
    isUserVerified: userIsUserVerified,
    verifyUser,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
}

export const appLogout = () => {
  if (process.env.REACT_APP_CLIENT !== "CT") {
    sessionStorage.clear();
  }
  window.top.postMessage({ type: "logout" }, process.env.REACT_APP_ADMIN);
  localStorage.removeItem("is-user-verified");
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  sessionStorage.clear();
};
